<script setup>
import { onMounted, ref } from 'vue'
import { apolloClient } from 'boot/apollo'
import potentialStats from 'src/graphql/potentialStatsQuery.gql'
import { wsClient } from 'boot/graphqlWS'
import CountUp from 'vue-countup-v3'
import { useUtils } from 'src/composables/useUtils'
import AppButton from '#/general/AppButton'

const { isVisible } = useUtils()
const stats = ref()
const animateNumbers = ref(false)
const playedOnce = ref(false)

const checkAnimateNumbers = async () => {
  const elements = document.getElementsByClassName('b2c-stats--title')
  let element
  if (elements && elements[0]) {
    element = elements[0]
    animateNumbers.value = isVisible(element)
    if (animateNumbers.value) {
      playedOnce.value = true
    }
  }
}

onMounted(() => {
  window.addEventListener('scroll', () => {
    if (!playedOnce.value) {
      checkAnimateNumbers()
    }
  })
})

await loadPotentialStats()

async function loadPotentialStats () {
  try {
    const res = await apolloClient.query({
      query: potentialStats
    })
    stats.value = res?.data?.potentialStats
  } catch (e) {
    console.log(e)
  }
}

onMounted(() => {
  wsClient.subscribe(
    {
      query: `
            subscription {
              potentialStatsSub {
                analyzedGrossFloorAreaPotentialSum
                buildingRegulationCityCount
                analyzedPotentials
              }
            }`
    },
    {
      next: val => {
        stats.value = val.data?.potentialStatsSub
      },
      error: e => console.log('error: ', e),
      complete: res => console.log('complete: ', res)
    }
  )
})

const options = { decimal: '.', separator: "'" }
</script>

<template lang='pug'>
.b2c-stats(v-if="stats")
  .routerPageSize
    .b2c-stats--title Unser Angebot ist fundiert und bewährt.
    .b2c-stats--cards
      .b2c-stats--card
        .b2c-stats--card-title
          .count-ups--container
            count-up(:end-val='Math.round(stats.analyzedGrossFloorAreaPotentialSum)' :options='options' :decimal-places="2" separator="'" :duration="4" v-if="animateNumbers")
            span(v-else) 0
            span.b2c-stats-square-meter  m
              .b2c-stats-square-meter-sign  2
        .b2c-stats--card-details Wohnflächen- potenzial schweizweit aufgedeckt.
      .b2c-stats--card
        .b2c-stats--card-title
          count-up(:end-val='Math.round(stats.analyzedPotentials)' :options='options' :decimal-places="2" separator="'" :duration="4" v-if="animateNumbers")
          span(v-else) 0
        .b2c-stats--card-details Potenzialanalysen mit Kunden und Kundinnen durchgeführt.
      .b2c-stats--card
        .b2c-stats--card-title
          .count-ups--container
            count-up(:end-val='3186' :options='options' :decimal-places="2" separator="'" :duration="4" v-if="animateNumbers")
            span.b2c-stats-square-meter  m
              .b2c-stats-square-meter-sign  2
        .b2c-stats--card-details Wohnfläche entwickelt, realisiert oder in der Umsetzung.
  app-button.b2c-stats--btn(label="Jetzt Potenzial prüfen" @clicked="$emit('openAnalyzer')")
</template>

<style lang="sass">
.b2c-stats
  background: linear-gradient(152.99deg, #2F3849 24.83%, #21252E 103.84%)
  box-shadow: 0px 15px 30px rgba(166, 166, 166, 0.25)
  width: 100%
  display: flex
  justify-content: center
  position: relative
  margin-bottom: 26px
  .b2c-stats--title
    font-weight: 500
    line-height: 130%
    text-align: center
    color: #FFF
    @media screen and (min-width: 1024px)
      margin: 93px 0 79px
      font-size: 34px
    @media screen and (max-width: 1024px)
      margin: 14px 0 34px
      font-size: 24px
  .b2c-stats--cards
    display: grid
    justify-content: center
    width: 100%
    @media screen and (min-width: 1024px)
      margin-bottom: 135px
      grid-template-columns: repeat(3, minmax(0, 1fr))
      grid-gap: 35px
    @media screen and (max-width: 1024px)
      margin-bottom: 41px
      grid-template-columns: 1fr
      grid-gap: 35px
    .b2c-stats--card
      padding: 30px 30px 33px
      width: 100%
      background: rgba(255, 255, 255, 0.11)
      border-radius: 10px
      @media screen and (max-width: 1024px)
      .b2c-stats--card-title
        font-weight: 600
        line-height: 130%
        letter-spacing: 0.05em
        color: #5FEFC0
        padding-bottom: 15px
        @media screen and (min-width: 1200px)
          font-size: 50px
        @media screen and (max-width: 1200px) and (min-width: 1024px)
          font-size: 40px
        @media screen and (max-width: 1024px)
          font-size: 30px
        .count-ups--container
          display: flex
          flex-direction: row
          margin-right: 4px
          align-items: baseline
          .count-up
            display: flex
            flex-direction: row
            align-items: center
        .b2c-stats-square-meter
          font-weight: 600
          font-size: 25px !important
          line-height: 130%
          position: relative
          @media screen and (min-width: 1024px)
          @media screen and (max-width: 1024px)
          .b2c-stats-square-meter-sign
            position: absolute
            top: -5px
            right: -10px
            font-size: 14px
      .b2c-stats--card-details
        color: rgba(255, 255, 255, 0.8)
        font-weight: 500
        font-size: 34px
        line-height: 120%
        @media screen and (max-width: 1200px) and (min-width: 1024px)
          font-size: 28px
        @media screen and (max-width: 1024px)
          font-size: 24px
  .b2c-stats--btn
    position: absolute
    bottom: -26px
    left: calc(50% - 160px)
    background: #1F47CD
    border-radius: 10px
    width: 320px !important
    height: 52px
    @media screen and (min-width: 1024px)
      font-size: 20px !important
    @media screen and (max-width: 1024px)
      font-size: 16px !important
</style>
